package com.devi3east.bashbuddy.prizeList.requests

import com.devi3east.bashbuddy.prizeList.domain.models.PrizeType
import kotlinx.serialization.Serializable

@Serializable
data class CreatePrizeRequest(
    val prizeType: PrizeType,
    val title: String? = "",
    val serialNumber: String? = null,
    val ticketId: String? = null
)